import { EventEmitter, Injectable, Output, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IBusinessSiteVisitViewModel } from 'app/models/complaints/siteVisit';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class SiteVisitService {

  @Output() updateSiteVistEvent = new EventEmitter<number>();

  statusInitial = 'initial';
  statusFollowup = 'follow-up';
  statusPostRemediation = 'post remediation';

  public siteVisit: IBusinessSiteVisitViewModel = {} as IBusinessSiteVisitViewModel;

  // public businessId: number = 0;
  public complaintId: number = 0;

  public apiComplaint: string = environment.privateApi + 'complaintStaff/';

  private http = inject(HttpClient);

  updateTabs(tab: number) {
    this.updateSiteVistEvent.emit(tab);
  }

  getSiteVisitData(id: number){
    this.getSiteVisits(id).subscribe({
      next: response => {
        this.siteVisit = response;
        this.updateTabs(0);
        // this.dialogRef.close('saved');
      },
      error: e => {
        console.log("Could not get Site Visit data.");
      },
    });
  }

  // Site Visits

  getSiteVisits(businessId: number): Observable<IBusinessSiteVisitViewModel> {
    return this.http.get<IBusinessSiteVisitViewModel>(this.apiComplaint + 'getSiteVisits/' + businessId);
  }

  deleteSiteVisits(id: number, type: string): Observable<boolean> {
    return this.http.get<boolean>(this.apiComplaint + 'deleteSiteVisits/' + id + '/' + type);
  }

  saveSiteVisits(id: number, site: IBusinessSiteVisitViewModel): Observable<boolean> {
    return this.http.post<boolean>(this.apiComplaint + 'saveSiteVisits/' + id, site, httpOptions);
  }  

}
